export { default } from './favorite-entry-button';
